import React from 'react';
import styles from './profile-placeholder.scss';

const ProfilePlaceholder = () =>
  <div className={styles.container}>
    <div className={styles.card}>
      <div className={styles.cover}/>
      <div className={styles.photo}>
        <div className={styles.image}/>
      </div>

      <div className={styles.flexContainer}>
        <div className={styles.userInfo}>
          <p className={styles.name}/>
          <p className={styles.date}/>
        </div>

        <div className={styles.childrenContainer}/>

        <div className={styles.stats}>
          <div className={styles.section}>
            <p className={styles.smallCount}/>
            <p className={styles.smallLabel}/>
          </div>

          <div className={styles.section}>
            <p className={styles.count}/>
            <p className={styles.label}/>
          </div>

          <div className={styles.section}>
            <p className={styles.count}/>
            <p className={styles.label}/>
          </div>
        </div>
      </div>
    </div>
  </div>;

export default ProfilePlaceholder;



// WEBPACK FOOTER //
// ./app/components/profile-placeholder/profile-placeholder.js